import { Link } from 'react-router-dom';
import { useBasket } from '../context/BasketContext.jsx';
import { useStoreConfig } from '../context/StoreConfigContext.jsx';
import { useStoreUI } from '../context/StoreUIContext.jsx';
import { avatarUrl } from '../lib/minecraft.js';
import '../styles/components/TopbarStyle.css';

export function Topbar() {
  const { site } = useStoreConfig();
  const { loggedIn, username, count } = useBasket();
  const { openBasket, openLogin } = useStoreUI();

  return (
    <div className="topbar">
      <div className="topbar-left">
        <Link className="topbar-logo" to="/home/" aria-label={`${site.name} home`}>
          <img
            className="topbar-logo-img"
            src="/include/images/logo.png"
            alt={site.name}
            width="96"
            height="96"
            decoding="async"
          />
        </Link>
        <div className="topbar-brand-text">
          <strong>{site.name}</strong>
          <span>Official Store</span>
        </div>
      </div>

      <div className="topbar-actions">
        <button
          type="button"
          className={`basket${loggedIn ? '' : ' basket--guest'}`}
          onClick={() => (loggedIn ? openBasket() : openLogin())}
          aria-label={loggedIn ? 'Open basket' : 'Login to add items'}
        >
          <div className="basket-icon-wrap">
            {loggedIn ? (
              <img
                className="basket-avatar"
                src={avatarUrl(username, 64)}
                alt={username}
                width="32"
                height="32"
                decoding="async"
              />
            ) : (
              <i className="fa-solid fa-right-to-bracket" />
            )}
            <span className="basket-bubble" hidden={!loggedIn}>
              {count}
            </span>
          </div>
          <div className="basket-text">
            <strong>{loggedIn ? `${username}'s Basket` : 'Click to login'}</strong>
            <span>{loggedIn ? `${count} item${count === 1 ? '' : 's'}` : 'to add items'}</span>
          </div>
          <span className="basket-glow" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
